import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const tripPlannerPath = '/:regionCode/trip-planner'

export function shouldShowTripPlannerSaveEntryPoints(
  pathname = '',
  enableTripPlanner = config.ENABLE_TRIP_PLANNER,
) {
  return (
    !!enableTripPlanner ||
    !!matchLocaleAwarePath(pathname, { path: tripPlannerPath, exact: false })
  )
}

function useShouldShowTripPlannerSaveEntryPoints() {
  const pathname = useAppSelector((state) => state.router.location.pathname)

  return shouldShowTripPlannerSaveEntryPoints(
    pathname,
    config.ENABLE_TRIP_PLANNER,
  )
}

export default useShouldShowTripPlannerSaveEntryPoints
